import {
  LF_TOGGLE_PENCIL_ACTIVATION,
  LF_TOGGLE_ERASER_ACTIVATION,
  LF_ERASE_ALL
} from '../action-types/doodle-stage';

export function togglePencilActivation() {
  return {
    type: LF_TOGGLE_PENCIL_ACTIVATION
  };
}

export function toggleEraserActivation() {
  return {
    type: LF_TOGGLE_ERASER_ACTIVATION
  };
}

export function eraseAll() {
  return {
    type: LF_ERASE_ALL
  };
}
